import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "key-values__key" };
import { ref, watch } from 'vue';
import LocalizedUtils from "../util/LocalizedUtils";
const maxNestingLevel = 2;
export default /*@__PURE__*/ _defineComponent({
    __name: 'KeyValues',
    props: {
        properties: {},
        mask: {},
        maskValue: {},
        nesting: { type: Boolean },
        nestingLevel: {},
        variant: {}
    },
    setup(__props) {
        const props = __props;
        const propsValue = ref([]);
        init();
        watch(() => props.properties, init);
        function init() {
            propsValue.value = [];
            for (const key in props.properties) {
                const value = shouldMask(key)
                    ? (props.maskValue ?? '••••••')
                    : props.properties[key];
                propsValue.value.push({
                    key: key,
                    value: value,
                });
            }
        }
        function shouldMask(prop) {
            const defaults = ['password', 'secret', 'private'];
            for (const i in (props.mask ?? defaults)) {
                const mask = (props.mask ?? defaults)[i];
                if (prop.toLowerCase().indexOf(mask.toLowerCase()) !== -1) {
                    return true;
                }
            }
            return false;
        }
        function isObject(value) {
            return (typeof value) === 'object';
        }
        function isObjectArray(value) {
            return Array.isArray(value)
                && value.length > 0
                && isObject(value[0]);
        }
        function isLocalizedValue(value) {
            return LocalizedUtils.isLocalizedValue(value);
        }
        function findLocalizedValue(value) {
            return LocalizedUtils.findLocalizedValue(value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["key-values", 'key-values--' + (__props.variant || 'inline')])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsValue.value, (prop) => {
                    return (_openBlock(), _createElementBlock("dl", {
                        key: prop.key,
                        class: "key-values__prop"
                    }, [
                        _createElementVNode("dt", _hoisted_1, _toDisplayString(prop.key), 1),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("dd", {
                            class: _normalizeClass(["key-values__value", { 'key-values__value--masked': prop.value === (__props.maskValue ?? '••••••') }])
                        }, [
                            (isLocalizedValue(prop.value))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(findLocalizedValue(prop.value)), 1)
                                ], 64))
                                : (__props.nesting && (isObject(prop.value) || isObjectArray(prop.value)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (isObjectArray(prop.value))
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(prop.value, (elem, index) => {
                                                return (_openBlock(), _createBlock(_resolveDynamicComponent("key-values"), {
                                                    properties: elem,
                                                    nesting: (__props.nestingLevel ?? 0) < maxNestingLevel,
                                                    "nesting-level": (__props.nestingLevel ?? 0) + 1,
                                                    key: index
                                                }, null, 8, ["properties", "nesting", "nesting-level"]));
                                            }), 128))
                                            : (_openBlock(), _createBlock(_resolveDynamicComponent("key-values"), {
                                                key: 1,
                                                properties: prop.value,
                                                nesting: (__props.nestingLevel ?? 0) < maxNestingLevel,
                                                "nesting-level": (__props.nestingLevel ?? 0) + 1
                                            }, null, 8, ["properties", "nesting", "nesting-level"]))
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(prop.value === undefined || prop.value === null ? '–' : prop.value), 1)
                                    ], 64))
                        ], 2)
                    ]));
                }), 128))
            ], 2));
        };
    }
});
